<template>
    <div class="wrapper-updates">
        <div class="updates">
          <div class="toolbar sites__toolbar row justify-content-between">
            <div class="toolbar__left sites__actions col-12 col-lg-auto">
              <div v-show="showActions" class="actions">
                <button class="btn btn--primary" v-on:click="updateSelected">
                  {{ $t("updates.updateselected") }}
                </button>
              </div>
            </div>
            <div class="toolbar__right sites__search col-12 col-lg-auto">
              <div>
                <b-input-group>
                  <b-form-input
                    v-model="searchTerm"
                    class="form-control search mb-2 mb-lg-0 d-inline-block"
                    type="search"
                    v-bind:placeholder="$t('updates.searchterm')"
                    v-on:blur="changeSearch"
                    v-on:keyup.enter="changeSearch"
                  />
                  <b-input-group-append>
                    <button class="btn btn-primary">
                      <font-awesome-icon :icon="['fal','search']" class="fa-icon"></font-awesome-icon>
                    </button>
                  </b-input-group-append>
                </b-input-group>
              </div>
              <div class="ml-lg-2 mb-2 mb-lg-0 d-inline-block">
                <b-form-select
                  v-model="selectedSite"
                  :options="sitesSelect"
                  v-on:change="changeSearch"
                  v-on:keyup.enter="changeSearch"
                >
                  <template v-slot:first>
                    <option value="">{{ $t("updates.sitefilter") }}</option>
                  </template>
                </b-form-select>
              </div>
              <div class="ml-md-2 d-inline-block">
                <b-dropdown id="columns-dropdown"
                            v-bind:text="$t('tableheadings.columns')"
                            variant="outline-primary"
                >
                  <b-dropdown-form>
                    <b-form-checkbox-group
                      id="column-select"
                      v-model="tableColumns"
                      name="columnselection"
                      stacked
                    >
                      <b-form-checkbox
                        v-for="col in columns"
                        :key="col.name"
                        :value="col.name"
                        class="mb-3 m-2"
                      >
                        {{ $t('tableheadings.' + col.name ) }}
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-dropdown-form>
                </b-dropdown>
              </div>
              <div class="ml-2 mb-2 mb-lg-0 d-inline-block">
                <b-form-select
                  v-model="limit"
                  :options="limitOptions"
                  @change="limitChange"
                >
                </b-form-select>
              </div>

            </div>
          </div>

            <div class="table-responsive-lg">
              <table v-show="updatesAvailable || isFiltered" class="table table--overview">
                  <thead>
                  <tr>
                    <th class="small">
                        <b-form-checkbox
                            v-model="allSelected"
                            v-on:change="toggleAll"
                        >
                        </b-form-checkbox>
                    </th>

                    <table-heading
                      class="text-center"
                      v-bind="{name: 'site_name', selected: ['site_name'], sortEnabled: true, sort: sort, dir: dir}"
                      @notifysort="sortColumn"
                    ></table-heading>

                    <table-heading
                      class="text-center"
                      v-bind="{name: 'translated_name', selected: ['translated_name'], sortEnabled: true, sort: sort, dir: dir}"
                      @notifysort="sortColumn"
                    ></table-heading>

                    <table-heading
                      v-for="(col, index) in columns"
                      :key="index"
                      class="text-center"
                      v-bind="{name: col.name, selected: tableColumns, sortEnabled: col.sortEnabled, sort: sort, dir: dir}"
                      @notifysort="sortColumn"
                    >
                    </table-heading>
                      <th class="text-center">
                          <button class="btn btn--primary" v-on:click="updateViewablePage" @mousedown.prevent>
                              {{$t('updates.updateallonpage')}}
                          </button>
                      </th>
                  </tr>
                  </thead>
                  <tbody>
                  <update-item v-for="update in updates" :key="update.id" v-bind="update"></update-item>
                  </tbody>
                  <tfoot>
                  <tr>
                      <td colspan="6">
                          <nav v-show="showPagination" class="page navigation">
                              <b-pagination
                                      v-model="currentPage"
                                      align="left"
                                      v-bind:per-page="limit"
                                      v-bind:total-rows="total"
                                      v-on:change="goToPage"
                              >
                              </b-pagination>
                          </nav>
                      </td>
                  </tr>
                  </tfoot>
              </table>
            </div>
          <b-container v-show="!isFiltered && !updatesAvailable && !isLoading" class="no-items">
            <b-row class="no-updates">
              <b-col md="3">
                <img src="/images/monkey_small.svg">
              </b-col>
              <b-col md="9">
                <h2>
                  {{$t('site.alluptodate')}}
                </h2>
                <p v-html="$t('site.youaredoinggreat')"></p>
              </b-col>
            </b-row>
          </b-container>
        </div>
      <div v-if="!isLoading">
        <empty-list v-if="showEmpty" @resetFilters="resetFilters"></empty-list>
      </div>
    </div>
</template>
<script>

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import UpdateItem from './UpdateItem'
import mixins from '@/mixins'
import TableHeading from '@/components/Common/TableHeading.vue'
import EmptyList from '@/components/Common/EmptyList.vue'

export default {

  components: {
    EmptyList,
    UpdateItem,
    TableHeading
  },

  mixins: [mixins],

  computed: {
    ...mapGetters('common', ['isLoading']),

    ...mapState('updates', {
      updatesSelected: state => state.updatesSelected,
      allSelectedState: state => state.allSelected,
      globalUpdates: state => state.updates
    }),

    ...mapState('site', {
      globalSites: state => state.sites
    }),

    ...mapGetters('local', ['getListLimit']),

    ...mapGetters('local', { getColumns: 'getUpdatesColumns' }),

    showEmpty () {
      return this.updates.length === 0 && this.isFiltered === true
    },

    isFiltered () {
      return this.searchTerm !== '' || this.sitesSelect.length > 0
    },

    allSelected: {
      get () {
        return this.allSelectedState
      },
      set (value) {
        // just do nothing
      }
    },

    showActions () {
      return this.updatesSelected.length > 0
    },

    updatesAvailable () {
      return this.updates.length > 0
    }
  },

  data () {
    return {
      updates: [],
      currentPage: 1,
      total: 1,
      totalPages: 1,
      sort: 'name',
      dir: 'asc',
      searchTerm: '',
      sitesSelect: [],
      selectedSite: '',
      defaultSelectedColumns: [
        'type',
        'version',
        'next_version'
      ],
      columns: [
        { name: 'type', sortEnabled: true },
        { name: 'version', sortEnabled: true },
        { name: 'next_version', sortEnabled: true }
      ]
    }
  },

  methods: {
    ...mapMutations(['setViewname']),

    ...mapMutations('updates', [
      'setSelectAll',
      'unsetSelectAll'
    ]),

    ...mapMutations('common', [
      'startLoading',
      'endLoading'
    ]),

    ...mapActions('site', [
      'getSites'
    ]),

    ...mapActions('updates', [
      'getUpdates',
      'updateViewablePage',
      'updateSelected'
    ]),

    ...mapMutations('local', [
      'setListLimit'
    ]),

    ...mapMutations('local', { setColumns: 'setUpdatesColumns' }),

    resetFilters () {
      this.searchTerm = ''
      this.sitesSelect = []

      this.goToPage(1)
    },

    changeSearch () {
      this.unsetSelectAll()
      this.goToPage(1)
    },

    getSiteData () {
      let payload = {
        page: 1,
        limit: 1000,
        sort: 'name',
        dir: 'asc',
        search: ''
      }

      this.getSites(payload).then(
        response => {
          /*
            Don't use the repose data because we are converting data for easier usage, this is saved
            locally in the globalSites var to avoid naming conflicts
          */
          this.globalSites.data.forEach((item) => {
            let site = {
              value: item.id,
              text: item.data.name
            }

            this.sitesSelect.push(site)
          })
        }
      )
    },

    goToPage (page) {
      if (!this.isLoading) {
        this.startLoading()
      }

      const payload = {
        page: page,
        limit: this.limit,
        sort: this.sort,
        dir: this.dir,
        search: this.searchTerm,
        site: this.selectedSite
      }

      this.getUpdates(payload).then(
        response => {
          /*
            Don't use the repose data because we are converting data for easier usage, this is saved
            locally in the globalUpdates var to avoid naming conflicts
          */
          let pagination = response.meta.pagination
          if (pagination.current_page > pagination.total_pages) {
            payload.page = pagination.total_pages
            this.getUpdates(payload).then(
              response => {
                this.preparePage(this.globalUpdates)
                this.endLoading()
              })
          } else {
            this.preparePage(this.globalUpdates)
            this.endLoading()
          }
        }
      )
    },

    preparePage (data) {
      let meta = data.meta
      this.limit = meta.pagination.per_page
      this.total = meta.pagination.total
      this.totalPages = meta.pagination.total_pages
      this.currentPage = meta.pagination.current_page

      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages
      }

      this.updates = []

      data.data.forEach((e) => {
        this.updates.push(e)
      })
    },

    toggleAll (e) {
      if (this.allSelected) {
        this.unsetSelectAll(e)
      } else {
        this.setSelectAll(e)
      }
    }
  },

  mounted () {
    if (this.getColumns.length === 0) {
      this.setColumns(this.defaultSelectedColumns)
    }
  },

  created () {
    this.setViewname(this.$t('updates.viewtitle'))
    this.getSiteData()
    this.goToPage(1)
  }
}
</script>
